import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import moment from 'moment';
import { useSelector } from 'react-redux';
import 'react-datepicker/dist/react-datepicker.css';
import { toast } from 'react-hot-toast';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import { FaPaperclip, FaRegTrashCan } from 'react-icons/fa6';
import PaymentsComponent from '../estimation/paymentComponents/PaymentsComponent';
import ShipmentsComponent from '../estimation/components/ShipmentsComponent';
import { LuChevronDown, LuChevronUp } from 'react-icons/lu';
import { Dropdown } from 'react-bootstrap';
import { saveAs } from 'file-saver';
import Notes from 'ui-component/notes';
import PrivacyModeContent from 'ui-component/PrivacyModeContent';
import { getCurrencySymbol, numberFormatter } from 'utils/currency';
import { CommonDateOnlyFormat } from 'helpers/common.helper';
import { useQuery, useQueryClient } from 'react-query';
import { deleteLocalStorageCacheItem } from 'helpers/common.helper';
import md5 from 'md5-hash';

import { DeleteIcon, InvoiceIcon } from 'ui-component/custom-icons/icons';
import DeleteConfirmation from 'ui-component/confirmation-dialogs/deleteConfirmation/DeleteConfirmation';
import agreementImage from 'assets/images/agreement.svg';
import StatusBadge from 'ui-component/StatusBadge';

import SendEmailModal from '../estimation/modals/SendEmailModal';
import PurchaseOrderModal from '../estimation/modals/PurchaseOrderModal';
import ProcessOrderModal from './modals/ProcessOrderModal';
import TimelineStep from 'ui-component/TimelineStep';
import _ from 'lodash'; // Add this at the top with other imports
import SalesOrderDetailInvoice from './SalesOrderDetailInvoice';
import PurchaseOrderComponent from './components/PurchaseOrderComponent';
import PicklistComponent from './components/PicklistComponent';
import InvoiceComponent from './components/InvoiceComponent';
import QoutationComponent from './components/QoutationComponent';
import ProductOverviewComponent from './components/ProductOverviewComponent';
import Timeline from 'ui-component/Timeline';
import { Skeleton } from '@mui/material';
import useIsMobile from 'utils/isMobileUtils';
import SendEmailModalMobile from 'views/estimation/modals/SendEmailMobileModal';


import usePageTitle from 'hooks/usePageTitle';

// ✅ Clear

const SalesOrderDetails = () => {
	const { id } = useParams();
	const [userName] = useSelector((state) => [state.main.user.first_name + ' ' + state.main.user.last_name]);
	

	const [setPageTitle] = usePageTitle('Sales Order'); 

	const [isInternalLoading, setInternalLoading] = useState(false);
	
	const [isExtraDropdownOpen, setIsExtraDropdownOpen] = useState(false);

	const [selectedSalesOrder, setSelectedSalesOrder] = useState();
	const [showDeletePayment, setShowDeletePayment] = useState(null);
	const [showActions, setShowActions] = useState(false);
	const [showDeletePopup, setShowDeletePopup] = useState(false);
	const [selectedPaymentId, setSelectedPaymentId] = useState(null);
	const [showCancelPopup, setShowCancelPopup] = useState(false);
	const [showDeleteSalesOrderPopup, setShowDeleteSalesOrderPopup] = useState(false);
	const [showClosePopup, setShowClosePopup] = useState(false);
	const [openSendEmailPopup, setOpenSendEmailPopup] = useState(false);
	const [sendingSalesOrder, setSendingSalesOrder] = useState(false);
	const [selectedForSending, setSelectedForSending] = useState('');
	const [showPurchaseOrderModal, setShowPurchaseOrderModal] = useState(null);
	const [showProcessOrderModal, setShowProcessOrderModal] = useState(false);
	

	const currentDate = moment().format('YYYY-MM-DD');

	const statusAllowedToDeleteDraft = ['Draft'];
	const statusAllowedToCancel = ['Open'];

	const statusAllowedToPayAndSalesOrder = ['Draft', 'Canceled', 'Closed'];

	// End Create
	const history = useNavigate();
	const [modalPrice, setModalprice] = useState('00');

	const [shippingRow, setShippingrow] = useState({
		quantity: 1,
		unitPrice: 0,
		totalPrice: 0
	});

	const [selectedCustomerinfo, setSelectedCustomerInfo] = useState({});
	const [subTotal, setSubtotal] = useState('00');
	const [paymentData, setPaymentData] = useState([]);
	const [deleteMessage, setDeleteMessage] = useState('');

	const [orderAgreementsData, setOrderAgreementsData] = useState([]);
	const [selectedPaymentShipment, setSelectedPaymentShipment] = useState('payment');
	const queryClient = useQueryClient();
	const location = useLocation();

	const openSendEmailModal = (type) => {
		setOpenSendEmailPopup(type);
	};
	
	const queryParams = new URLSearchParams(location.search);

	const closeSendEmailPopup = () => {
		setOpenSendEmailPopup(false);
	};


	const { data: requestData } = useQuery(
		['salesorder-details', id, location],
		() => {
			const queryParams = new URLSearchParams(location.search);
            setShowActions(true);
            return api.getSalesOrderById(id);
		},
		{
		},
	);

	const invalidateEstQuery = () => {
		queryClient.prefetchQuery({ queryKey: ['salesorder-details', id, location] });
	};

	const [showAddPaymentModal, setShowAddPaymentModal] = useState(false);


	const handleClosePopup = () => {
		setShowDeletePopup('')	
		setShowCancelPopup(false)
		setShowClosePopup(false)
		setShowProcessOrderModal(false)
		setShowDeletePayment(false)
	}

	const handleSendEmail = (data) => {
		setSendingSalesOrder(true);
		toast.promise(
			api.sendSalesOrderByEmail(data).then(
				(res) => {
					invalidateEstQuery();
					if (res.status) {
						deleteLocalStorageCacheItem(md5(`salesorder-details-${id}-${selectedSalesOrder?.ref}`));
						setOpenSendEmailPopup(false);
					} else {
						toast.error(`Sending email failed. Please try again.`);
					}
					setSendingSalesOrder(false);

					return res?.status ? res : null;
				},
				() => {}
			),
			{
				loading: `Sending...`,
				success: (data) => `${data.message}`,
				error: <b>Failed to send email</b>
			}
		);
	};

	const handleAddPayment = (data) => {

		deleteLocalStorageCacheItem(md5(`salesorder-details-${id}-${selectedSalesOrder?.ref}`));
		invalidateEstQuery();
	};

	const handlePaymentToggle = (index) => {
		setPaymentData((oldData) =>
			oldData?.map((p, i) =>
				i == index
					? {
							...p,
							expand: p?.expand ? false : true
					  }
					: p
			)
		);
	};


	const handleDeleteSalesOrder = () => {
		
		toast.promise(
			api.deleteSalesOrderRollbackSequence(selectedSalesOrder?.id).then((res) => {
				if (res.status) {
					deleteLocalStorageCacheItem(md5(`salesorder-details-${id}-${selectedSalesOrder?.ref}`));
					invalidateEstQuery();
					history(`/sales/sales-orders`);
				}
				setShowDeleteSalesOrderPopup(false)
			}),
			{
				loading: 'Deleting Sales Order...',
				success: <b>Sales Order deleted</b>,
				error: <b>Could not delete Sales Order.</b>
			}
		);

	};
	const closePurchaseOrderPopup = () => {
		setShowPurchaseOrderModal('');
	};

	const handleUpdatePayment = (data) => {
		deleteLocalStorageCacheItem(md5(`salesorder-details-${id}-${selectedSalesOrder?.ref}`));
		invalidateEstQuery();
	};

	const handleDeletePayment = (data) => {
		
		toast.promise(
			api.deleteEstimatePayment(selectedPaymentId).then((res) => {
				if (res.status) {
					deleteLocalStorageCacheItem(md5(`salesorder-details-${id}-${selectedSalesOrder?.ref}`));
					handleClosePopup()
					setSelectedPaymentId(null);
					invalidateEstQuery();
				}

				return res?.status == true ? res : null;
			}),

			{
				loading: 'Deleting Payment...',
				success: (data) => `${data.message}`,
				error: <b>Payment Delete Failed</b>
			}
		);
	};

	const [salesOrderRow, setSalesOrderRow] = useState({
		customer_id: '',
		sales_order_number: '',
		sales_manager: '',
		transit_id: '',
		vatStatus: 'Including VAT',
		vatPrice: 21,
		startDate: currentDate,
		expiresIn: 7,
		currency: 'eur',
		notes: []
	});
	// Row Area
	const [rows, setRows] = useState([{ id: 1, modelId: '', type: '', quantity: 0, unitPrice: 0, total: 0 }]);


	useEffect(() => {
		setSalesOrderRow((oldData) => ({ ...oldData, sales_manager: selectedCustomerinfo?.sales_manager_id }));
	}, [selectedCustomerinfo]);

	useEffect(() => {
		initiateDatas();

	}, [location]);

	const [totalProductOverviewItems, setTotalProductOverviewItems] = useState(0);
	useEffect(() => {
		if (requestData?.data?.data) {
			setSelectedSalesOrder(requestData?.data?.data);
			if (requestData?.data?.data?.payments) {
				setPaymentData([...requestData?.data?.data?.payments]);
			}
			if (requestData?.data?.data?.product_overview) {
				const computeItems = requestData?.data?.data?.product_overview?.reduce((acc, item) => acc + (parseInt(item?.product_stock_comparison?.reserved_qty)), 0);
				const calculatePendingQty = requestData?.data?.data?.sales_order_item_quantity - requestData?.data?.data?.total_items_shipped || 0;
				setTotalProductOverviewItems(calculatePendingQty);
			}

			
			setInternalLoading(false)
			
			setOrderAgreementsData(requestData?.data?.data.order_agreements);
		}
	}, [requestData]);

	const initiateDatas = () => {
		if (id) {
		} else {
			history(`/sales/sales-orders`);
		}
	};

	const handleCreatePurchaseOrder = (details, items) => {
		let data = details;
		data['items'] = items;
	}

	const addNote = (noteInputValue, noteType, mentions, noteInputPlain) => {
		toast.promise(
			api
				.newSalesOrderNote(id, {
					details: noteInputValue,
					detail_plain: noteInputPlain,
					type: 'public',
					todo: noteType == 'todo' ? true : false,
					mentions
				})
				.then(
					(res) => {
						if (res.status) {
							setSalesOrderRow((oldData) => ({
								...oldData,
								notes: [
									{
										id: res?.data?.id,
										details: noteInputValue,
										date: moment(res?.data?.created_at).format('YYYY-MM-DD'),
										time: moment(res?.data?.created_at).format('HH:mm'),
										user_name: userName,
										expand: false,
										isDeletable: true
									},
									...oldData?.notes
								]
							}));
						}

						return res?.status ? res : null;
					},
					() => {}
				),
			{
				loading: 'Adding Note...',
				success: (data) => `${data.message}`,
				error: <b>Failed to add note</b>
			}
		);
	};

	const toggleNoteExpand = (index) => {
		setSalesOrderRow((oldData) => ({
			...oldData,
			notes: oldData?.notes?.map((note, i) =>
				index == i
					? {
							...note,
							expand: !note?.expand
					  }
					: note
			)
		}));
	};

	const removeNote = (index) => {
		toast.promise(
			api.removeEstimateNote(id, salesOrderRow?.notes?.[index]?.id).then(
				(res) => {
					if (res.status) {
						setSalesOrderRow((oldData) => ({
							...oldData,
							notes: oldData?.notes?.filter((note, i) => index != i)
						}));
					}

					return res?.status ? res : null;
				},
				() => {}
			),
			{
				loading: 'Deleting Note...',
				success: (data) => `${data.message}`,
				error: <b>Failed to delete note</b>
			}
		);
	};

	useEffect(() => {
		if (selectedSalesOrder) {
			const expDate = moment(selectedSalesOrder?.expires_at).format('YYYY-MM-DD');
			let tempRow = selectedSalesOrder?.sales_order_items?.map((item, index) => {
				return {
					id: index,
					modelId: item?.product_id,
					type: item?.product?.product_name,
					quantity: item?.qty,
					unitPrice: Number(item?.unit_price),
					total: item?.total_price
				};
			});

			tempRow = [
				...tempRow,
				{
					id: tempRow.length + 1,
					modelId: '',
					type: '',
					quantity: '',
					unitPrice: '',
					total: ''
				}
			];

			setRows(tempRow);
			setSelectedCustomerInfo(selectedSalesOrder.customer);
			setSubtotal(selectedSalesOrder?.subtotal);

			const tempSalesOrder = {
				sales_order_number: selectedSalesOrder?.sales_order_number,
				customer_id: selectedSalesOrder?.customer_id,
				startDate: selectedSalesOrder?.start_at,
				expiryDate: expDate,
				transit_id: selectedSalesOrder?.transit_company?.id,
				sales_manager: selectedSalesOrder?.sales_person?.id,
				private_note: selectedSalesOrder?.private_note,
				vatStatus: selectedSalesOrder?.vat_type,
				vatPrice: selectedSalesOrder?.vat_percent || 21,
				currency: selectedSalesOrder?.currency,
				private_note: selectedSalesOrder?.private_note,
				expiresIn: moment(selectedSalesOrder?.expires_at).diff(selectedSalesOrder?.start_at, 'days')
			};

			let notesArray = [];

			selectedSalesOrder?.notes?.forEach((note) => {
				notesArray = [
					{
						id: note?.id,
						details: note?.details,
						date: moment(note?.created_at).format('YYYY-MM-DD'),
						time: moment(note?.created_at).format('HH:mm'),
						user_name: `${note?.user_created?.first_name} ${note?.user_created?.last_name}`,
						expand: false,
						isDeletable: note?.is_deletable
					},
					...notesArray
				];
			});

			notesArray = _.sortBy(notesArray, (n) => -n.id);

			setSalesOrderRow({ ...tempSalesOrder, notes: notesArray });
		}
	}, [selectedSalesOrder]);

	const calculateTotal = () => {
		let total = 0;
		let grandTotal = 0;
		for (let i = 0; i < rows.length; i++) {
			const { quantity, unitPrice } = rows[i];
			total += parseFloat(quantity || 0) * parseFloat(unitPrice || 0);
		}

		if (shippingRow?.totalPrice > 0) {
			const shippingTotal = parseFloat(shippingRow.totalPrice);
			grandTotal = total + shippingTotal;
		} else {
			grandTotal = total;
		}

		if (isNaN(grandTotal)) {
			return { subtotal: '00', modelTotal: '00' };
		}
		return { subtotal: grandTotal, modelTotal: total };
	};

	useEffect(() => {
		let tempsubtotal = calculateTotal();
		const subTotals = parseFloat(tempsubtotal?.subtotal).toFixed(2);
		const modaltotal = parseFloat(tempsubtotal?.modelTotal).toFixed(2);
		setSubtotal(subTotals);
		setModalprice(modaltotal);
	}, [rows, shippingRow, salesOrderRow]);

	useEffect(() => {
		if (salesOrderRow?.vatStatus == 'Excluding VAT' && salesOrderRow?.vatPrice > 0) {
			let tempvat = (modalPrice * (salesOrderRow?.vatPrice / 100)).toFixed(2);
			let temTotal = (parseFloat(subTotal) + parseFloat(tempvat)).toFixed(2);
		}
	}, [subTotal, modalPrice, salesOrderRow]);

	const downloadSalesOrder = (template, to) => {
		api.downloadSalesOrder(id, { template, to }).then((res) => {
			// if (res?.status) {

			var newBlob = new Blob([res], { type: 'application/pdf' });
			saveAs(
				newBlob,
				`Sales Order ${selectedSalesOrder?.sales_order_number}.pdf`
			);
		});
	};

	const handleReloadDetails = () => {
		
		invalidateEstQuery();
		handleClosePopup()
	}
	

	


	const cancelSalesOrder = (data) => {
		setDeleteMessage(`By canceling, this Sales Order ${ data?.sales_order_number} cannot be rolled back. Do you want to proceed?`);
		setShowCancelPopup(data);
	};

	const handleCancel = (id) => {
		toast.promise(
			api.cancelSalesOrder(id).then((res) => {
				if (res.status) {
					invalidateEstQuery();
					history(`/sales/sales-orders`);
				}
			}),
			{
				loading: 'Canceling Sales order...',
				success: <b>Sales order cancelled</b>,
				error: <b>Could not cancel sales order.</b>
			}
		);
	}

	const handleCloseSalesOrder = (id) => {
		toast.promise(
			api.closeSalesOrder(id).then((res) => {
				if (res.status) {
					invalidateEstQuery();
					history(`/sales/sales-orders`);
				}
			}),
			{
				loading: 'Closing Sales order...',
				success: <b>Sales order closed</b>,
				error: <b>Could not close sales order.</b>
			}
		);
	}

	const deleteSalesOrder = (data) => {
		setDeleteMessage(
			`Are you sure you want to delete <br />sales order ${ data?.sales_order_number}?`
		);
		setShowDeletePopup(data);
	};

	const handleDelete = (id) => {

		toast.promise(
			api.deleteSalesOrder(id).then((res) => {
				if (res.status) {
					invalidateEstQuery();
					history(`/sales/sales-orders`);
				}
			}),
			{
				loading: 'Deleting Sales Order...',
				success: <b>Sales Order deleted</b>,
				error: <b>Could not delete sales order.</b>
			}
		);
	};

	const deletePayment = (id) => { 
		setShowDeletePayment(true);
		setSelectedPaymentId(id);
	}

	const handleCreateInvoice = () => {

		toast.promise(
			api.createInvoiceFromSalesOrder({
				sales_order_id: id
			}).then((res) => {
				if (res.status) {
					history(`/sales/invoices/${res?.data?.invoice_id}`);
				}
			}),
			{
				loading: 'Creating Invoice...',
				success: <b>Invoice created</b>,
				error: <b>Could not create invoice.</b>
			}
		);
	}
	
	const duplicateSalesOrderAsSalesOrder = (id) => {
		toast.promise(
			api
				.duplicateSalesOrderAsSalesOrder(id)
				.then((res) => {
					if (res.status) {
						history(`/sales/sales-orders/${res?.data?.sales_order_id}`);
					}
				}),
			{
				loading: 'Creating Sales Order...',
				success: <b>Sales Order Created</b>,
				error: <b>Could not create Sales Order.</b>
			}
		);
	}
	const duplicateSalesOrderAsInvoice = (id) => {
		toast.promise(
			api
				.duplicateSalesOrderAsInvoice(id)
				.then((res) => {
					if (res.status) {
						history(`/sales/invoices/${res?.data?.invoice_id}`);
					}
				}),
			{
				loading: 'Creating Sales Order...',
				success: <b>Sales Order Created</b>,
				error: <b>Could not create Sales Order.</b>
			}
		);
	}

	const isMobile = useIsMobile();

	return (
		<div className="row m-0 w-100 est-nv-container sales-container">
			<div className="col-12 col-md-8 col-lg-8 col-xl-9 p-0 p-md-2 inv-preview">
				<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
					<div className="header-bubble" />
					<div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
						<div
							style={{
								position: 'relative',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								marginBottom: 8,
								minHeight: 38 // ensures enough height for the button
							}}
						>
							{' '}
							<button
								type="button"
								aria-label="Back"
								onClick={() => history(-1)}
								className="circle-back-btn"
								style={{
									position: 'absolute',
									left: 20,
									top: '50%',
									transform: 'translateY(-50%)'
								}}
							>
								{/* Replace with your fi arrow icon, example below */}
								<svg width="22" height="22" fill="none" viewBox="0 0 24 24">
									<path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
								</svg>
							</button>
							<div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10}}>
								<h5 style={{ textAlign: 'center', flex: 1, margin: 0, whiteSpace: 'nowrap' }}>{selectedSalesOrder?.sales_order_number}</h5>
								<StatusBadge itemStatus={selectedSalesOrder?.master_status?.name} />
							</div>
						</div>
						<div
							className={`${
								selectedSalesOrder?.master_status?.name === 'Draft' || selectedSalesOrder?.master_status?.name === 'Paid'
									? 'centered-buttons'
									: !statusAllowedToPayAndSalesOrder.includes(selectedSalesOrder?.master_status?.name)
									? 'horizontal-scroll'
									: 'centered-buttons'
							}`}
							style={{ paddingLeft: 20, paddingRight: 20 }}
						>
							<button
								type="button"
								className="btn btn-primary btn-outlined-main white-var"
								style={{ minWidth: 'unset' }}
								onClick={() => {
									openSendEmailModal(`sales_order`);
									setSelectedForSending(selectedSalesOrder?.id);
								}}
								disabled={isInternalLoading || !salesOrderRow?.sales_order_number}
							>
								<svg
									id="fi_2983788"
									enable-background="new 0 0 512.005 512.005"
									height="18"
									viewBox="0 0 512.005 512.005"
									width="18"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g>
										<path
											d="m511.658 51.675c2.496-11.619-8.895-21.416-20.007-17.176l-482 184c-5.801 2.215-9.638 7.775-9.65 13.984-.012 6.21 3.803 11.785 9.596 14.022l135.403 52.295v164.713c0 6.948 4.771 12.986 11.531 14.593 6.715 1.597 13.717-1.598 16.865-7.843l56.001-111.128 136.664 101.423c8.313 6.17 20.262 2.246 23.287-7.669 127.599-418.357 122.083-400.163 122.31-401.214zm-118.981 52.718-234.803 167.219-101.028-39.018zm-217.677 191.852 204.668-145.757c-176.114 185.79-166.916 176.011-167.684 177.045-1.141 1.535 1.985-4.448-36.984 72.882zm191.858 127.546-120.296-89.276 217.511-229.462z"
											fill="currentColor"
										></path>
									</g>
								</svg>
								Send
							</button>
							<button
								type="button"
								className="btn btn-primary btn-outlined-main white-var"
								style={{ minWidth: 'unset' }}
								disabled={isInternalLoading || !salesOrderRow?.sales_order_number}
								onClick={() => {
									if (selectedSalesOrder?.transit_company?.name) {
										downloadSalesOrder('invoice', 'transitcompany');
									} else {
										downloadSalesOrder('invoice', 'customer');
									}
								}}
							>
								<svg
									id="fi_2767144"
									enable-background="new 0 0 128 128"
									height="18"
									viewBox="0 0 128 128"
									width="18"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										id="Download"
										d="m128 65c0 15.439-12.563 28-28 28h-20c-2.211 0-4-1.791-4-4s1.789-4 4-4h20c11.027 0 20-8.973 20-20s-8.973-20-20-20h-4c-2.211 0-4-1.791-4-4 0-15.439-12.563-28-28-28s-28 12.561-28 28c0 2.209-1.789 4-4 4h-4c-11.027 0-20 8.973-20 20s8.973 20 20 20h20c2.211 0 4 1.791 4 4s-1.789 4-4 4h-20c-15.437 0-28-12.561-28-28s12.563-28 28-28h.223c1.996-17.975 17.277-32 35.777-32s33.781 14.025 35.777 32h.223c15.438 0 28 12.561 28 28zm-50.828 37.172-9.172 9.172v-50.344c0-2.209-1.789-4-4-4s-4 1.791-4 4v50.344l-9.172-9.172c-1.563-1.563-4.094-1.563-5.656 0s-1.563 4.094 0 5.656l16 16c.781.781 1.805 1.172 2.828 1.172s2.047-.391 2.828-1.172l16-16c1.563-1.563 1.563-4.094 0-5.656s-4.094-1.563-5.656 0z"
										fill="currentColor"
									></path>
								</svg>
								Download
							</button>
							{!statusAllowedToPayAndSalesOrder.includes(selectedSalesOrder?.master_status?.name) && (
								<PermissionAllowed permissions={['Create New Estimation (Action)']}>
									{!selectedSalesOrder?.invoice?.id && (
										!selectedSalesOrder ? (
											<div style={{ width: '110px' }}>
												<Skeleton variant="rounded" width={'100%'} height={26}></Skeleton>
											</div>
										) : (
											<button
												type="button"
												className="btn btn-primary btn-outlined-main white-var"
												style={{ minWidth: 'unset' }}
												disabled={isInternalLoading || !salesOrderRow?.sales_order_number}
												onClick={() => {
													handleCreateInvoice();
												}}
											>
												<InvoiceIcon width="18px" height="18px" />
												Billed
											</button>
										)
									)}
								</PermissionAllowed>
							)}
							{selectedSalesOrder?.payments?.length < 1 && (
								<>
									{!selectedSalesOrder ? (
										<div style={{ width: '110px' }}>
											<Skeleton variant="rounded" width={'100%'} height={26}></Skeleton>
										</div>
									) : (
										<PermissionAllowed permissions={['Delete Sales Order']}>
											{statusAllowedToDeleteDraft.includes(selectedSalesOrder?.master_status?.name) && (
												<button
													type="button"
													className="btn btn-primary btn-outlined-danger white-var"
													style={{ minWidth: 'unset' }}
													disabled={isInternalLoading || !salesOrderRow?.sales_order_number}
													onClick={() => {
														deleteSalesOrder(selectedSalesOrder);
													}}
												>
													<FaRegTrashCan />
													Delete Draft
												</button>
											)}
										</PermissionAllowed>
									)}

									{selectedSalesOrder?.master_status?.name && selectedSalesOrder?.master_status?.name !== 'Draft' && (
										statusAllowedToCancel.includes(selectedSalesOrder?.master_status?.name) && (
											<PermissionAllowed permissions={['Edit Sales Order']}>
												<Dropdown
													className="btnDel est-btn iconbtn"
													align={'end'}
													onToggle={(isOpen) => setIsExtraDropdownOpen(isOpen)}
												>
													<Dropdown.Toggle as="span">
														<Link to={''} className="btn btn-primary btn-outlined-main white-var" style={{ minWidth: 'unset' }}>
															Extra {isExtraDropdownOpen ? <LuChevronUp /> : <LuChevronDown />}
														</Link>
													</Dropdown.Toggle>
													<Dropdown.Menu>
														{statusAllowedToCancel.includes(selectedSalesOrder?.master_status?.name) && (
															<>
																<PermissionAllowed permissions={['Cancel Sales Order']}>
																	<Dropdown.Item
																		onClick={() => {
																			cancelSalesOrder(selectedSalesOrder);
																		}}
																	>
																		Cancel
																	</Dropdown.Item>
																</PermissionAllowed>
															</>
														)}

														{selectedSalesOrder?.is_allowed_to_delete && (
															<PermissionAllowed permissions={['Delete Sales Order']}>
																<Dropdown.Item
																	onClick={() => {
																		setShowDeleteSalesOrderPopup(true);
																	}}
																>
																	Delete
																</Dropdown.Item>
															</PermissionAllowed>
														)}
													</Dropdown.Menu>
												</Dropdown>
											</PermissionAllowed>
										)
									)}
								</>
							)}
						</div>
					</div>
				</div>

				<div className="section-head-new pl-0 mb-1 mt-2 hide-on-mobile">
					<div className="actions" style={{ gap: '5px', width: 'auto' }}>
						{showActions && (
							<>
								{!selectedSalesOrder ? (
									<div style={{ width: '90px' }}>
										<Skeleton variant="rounded" width={'100%'} height={26}></Skeleton>
									</div>
								) : (
									<button
										type="button"
										className="btn btn-primary btn-outlined-main white-var"
										style={{ minWidth: 'unset' }}
										onClick={() => {
											openSendEmailModal(`sales_order`);
											setSelectedForSending(selectedSalesOrder?.id);
										}}
										disabled={isInternalLoading || !salesOrderRow?.sales_order_number}
									>
										<svg
											id="fi_2983788"
											enable-background="new 0 0 512.005 512.005"
											height="18"
											viewBox="0 0 512.005 512.005"
											width="18"
											xmlns="http://www.w3.org/2000/svg"
										>
											<g>
												<path
													d="m511.658 51.675c2.496-11.619-8.895-21.416-20.007-17.176l-482 184c-5.801 2.215-9.638 7.775-9.65 13.984-.012 6.21 3.803 11.785 9.596 14.022l135.403 52.295v164.713c0 6.948 4.771 12.986 11.531 14.593 6.715 1.597 13.717-1.598 16.865-7.843l56.001-111.128 136.664 101.423c8.313 6.17 20.262 2.246 23.287-7.669 127.599-418.357 122.083-400.163 122.31-401.214zm-118.981 52.718-234.803 167.219-101.028-39.018zm-217.677 191.852 204.668-145.757c-176.114 185.79-166.916 176.011-167.684 177.045-1.141 1.535 1.985-4.448-36.984 72.882zm191.858 127.546-120.296-89.276 217.511-229.462z"
													fill="currentColor"
												></path>
											</g>
										</svg>
										Send
									</button>
								)}

								{!selectedSalesOrder ? (
									<div style={{ width: '110px' }}>
										<Skeleton variant="rounded" width={'100%'} height={26}></Skeleton>
									</div>
								) : (
									<button
										type="button"
										className="btn btn-primary btn-outlined-main white-var"
										style={{ minWidth: 'unset' }}
										disabled={isInternalLoading || !salesOrderRow?.sales_order_number}
										onClick={() => {
											if (selectedSalesOrder?.transit_company?.name) {
												downloadSalesOrder('invoice', 'transitcompany');
											} else {
												downloadSalesOrder('invoice', 'customer');
											}
										}}
									>
										<svg
											id="fi_2767144"
											enable-background="new 0 0 128 128"
											height="18"
											viewBox="0 0 128 128"
											width="18"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												id="Download"
												d="m128 65c0 15.439-12.563 28-28 28h-20c-2.211 0-4-1.791-4-4s1.789-4 4-4h20c11.027 0 20-8.973 20-20s-8.973-20-20-20h-4c-2.211 0-4-1.791-4-4 0-15.439-12.563-28-28-28s-28 12.561-28 28c0 2.209-1.789 4-4 4h-4c-11.027 0-20 8.973-20 20s8.973 20 20 20h20c2.211 0 4 1.791 4 4s-1.789 4-4 4h-20c-15.437 0-28-12.561-28-28s12.563-28 28-28h.223c1.996-17.975 17.277-32 35.777-32s33.781 14.025 35.777 32h.223c15.438 0 28 12.561 28 28zm-50.828 37.172-9.172 9.172v-50.344c0-2.209-1.789-4-4-4s-4 1.791-4 4v50.344l-9.172-9.172c-1.563-1.563-4.094-1.563-5.656 0s-1.563 4.094 0 5.656l16 16c.781.781 1.805 1.172 2.828 1.172s2.047-.391 2.828-1.172l16-16c1.563-1.563 1.563-4.094 0-5.656s-4.094-1.563-5.656 0z"
												fill="currentColor"
											></path>
										</svg>
										Download
									</button>
								)}
							</>
						)}
					</div>
					<div className="actions" style={{ gap: '5px' }}>

						<div className="est-detail-item">
							{!selectedSalesOrder ? (
								<div style={{ marginTop: '-6px', marginBottom: '9px' }}>
									<Skeleton variant="rounded" width={'100%'} height={40}></Skeleton>
								</div>
							) : (
								<StatusBadge itemStatus={selectedSalesOrder?.is_draft == 1 ? 'Draft' : selectedSalesOrder?.master_status?.name} />
							)}
						</div>
						<PermissionAllowed permissions={['Edit Sales Order']}>
							<Dropdown
								className="btnDel est-btn iconbtn"
								align={'end'}
								onToggle={(isOpen) => setIsExtraDropdownOpen(isOpen)}
							>
								<Dropdown.Toggle as="span">
									<Link to={''} className="btn btn-primary btn-outlined-main white-var" style={{ minWidth: 'unset' }}>
										Extra {isExtraDropdownOpen ? <LuChevronUp /> : <LuChevronDown />}
									</Link>
								</Dropdown.Toggle>
								<Dropdown.Menu>
									{statusAllowedToDeleteDraft.includes(selectedSalesOrder?.master_status?.name) && (
										<PermissionAllowed permissions={['Delete Sales Order']}>
											<Dropdown.Item
												onClick={() => { deleteSalesOrder(selectedSalesOrder); }}
											>
												Delete Draft
											</Dropdown.Item>
										</PermissionAllowed>
									)}
									{!statusAllowedToPayAndSalesOrder.includes(selectedSalesOrder?.master_status?.name) && (
										<PermissionAllowed permissions={['Create New Estimation (Action)']}>
											<Dropdown.Item
												onClick={() => { handleCreateInvoice(); }}
											>
												Billed
											</Dropdown.Item>
										</PermissionAllowed>
									)}
									<PermissionAllowed permissions={['Create Sales Order']}>
										<Dropdown.Item
											onClick={() => { duplicateSalesOrderAsSalesOrder(selectedSalesOrder?.id); }}
										>
											Duplicate Sales Order
										</Dropdown.Item>
									</PermissionAllowed>
									<PermissionAllowed permissions={['Create New Estimation (Action)']}>
										<Dropdown.Item
											onClick={() => { duplicateSalesOrderAsInvoice(selectedSalesOrder?.id); }}
										>
											Duplicate to Invoice
										</Dropdown.Item>
									</PermissionAllowed>
									{statusAllowedToCancel.includes(selectedSalesOrder?.master_status?.name) && (
										<PermissionAllowed permissions={['Cancel Sales Order']}>
											<Dropdown.Item
												onClick={() => {
													cancelSalesOrder(selectedSalesOrder);
												}}
											>
												Cancel
											</Dropdown.Item>
										</PermissionAllowed>
									)}
									{selectedSalesOrder?.is_allowed_to_delete && (
										<PermissionAllowed permissions={['Delete Sales Order']}>
											<Dropdown.Item
												onClick={() => {
													setShowDeleteSalesOrderPopup(true);
												}}
											>
												Delete
											</Dropdown.Item>
										</PermissionAllowed>
									)}
								</Dropdown.Menu>
							</Dropdown>
						</PermissionAllowed>
					</div>
				</div>
				<div className="row hide-on-mobile">
					<div className="col-12">
						{!selectedSalesOrder ? (
							<div style={{ width: '100%', marginBottom: '8px' }}>
								<Skeleton variant="rounded" width={'100%'} height={160} style={{ borderRadius: '12px' }} />
							</div>
						) : (
							selectedSalesOrder?.master_status?.name !== 'Draft' && (
								<div>
									<Timeline
										id={id}
										source={'sales_order'}
										pendingQty={selectedSalesOrder?.pending_qty}
										productOverviewCount={totalProductOverviewItems}
									/>
								</div>
							)	
						)}
					</div>
				</div>
				<div className="row m-0 mobile-scroll-container">
					<div className="show-on-mobile" style={{ width: '100%', display: 'flex' }}>
						{!selectedSalesOrder ? (
							<div style={{ width: '100%', marginBottom: '8px' }}>
								<Skeleton variant="rounded" width={'100%'} height={36}></Skeleton>
							</div>
						) : (
							<div style={{ width: '100%', marginBottom: '8px', paddingTop: 10 }}>
								<Timeline
									// key={refreshKey}
									id={id}
									source={'sales_order'}
									pendingQty={selectedSalesOrder?.pending_qty}
									productOverviewCount={totalProductOverviewItems}
								/>
							</div>
						)}
					</div>
					<div className="mb-3 p-3 p-xl-4 w-100 new-card">
						<SalesOrderDetailInvoice salesOrder={selectedSalesOrder} isPageLoading={!selectedSalesOrder ? true : false} />
						{!isMobile && (
							<>
								<div style={{ height: '0px' }}></div>

								{selectedSalesOrder?.qoutation?.estimation_number && (
									<QoutationComponent details={selectedSalesOrder} isPageLoading={!selectedSalesOrder ? true : false} />
								)}
								{selectedSalesOrder?.invoice?.invoice_number && (
									<InvoiceComponent details={selectedSalesOrder} isPageLoading={!selectedSalesOrder ? true : false} />
								)}
								{totalProductOverviewItems > 0 && (
									<ProductOverviewComponent
										details={selectedSalesOrder}
										isPageLoading={!selectedSalesOrder ? true : false}
										onHandleLoadSalesOrder={() => {

											deleteLocalStorageCacheItem(md5(`salesorder-details-${id}-${selectedSalesOrder?.ref}`));
											invalidateEstQuery();
										}}
									/>
								)}
								{selectedSalesOrder?.payments?.length > 0 && (
									<div style={{ padding: '0px 20px 20px 16px' }}>
										<div className="row mb10">
											<div className="col-12">
												<h2 className="d-flex font600" style={{ fontSize: '18px' }}>
													Payments
												</h2>
											</div>
										</div>

										<div className="row">
											<div className="col-md-3 font600">Date</div>
											<div className="col-md-3 font600">Type</div>
											<div className="col-md-3 font600">Amount</div>
											<div className="col-md-3 font600">Processed By</div>
										</div>
										<hr className="mt8 mb8" />
										{selectedSalesOrder?.payments?.map((payment, index) => (
											<>
												<div className="row hover-row">
													<div className="col-md-3">{moment(payment?.payment_date).format(CommonDateOnlyFormat)}</div>
													<div className="col-md-3">
														{payment?.pay_type == 'credit-note' ? (
															payment?.credit_note?.credit_note_number ? (
																<div
																	className={`${
																		hasEveryPermission(['View Estimation Details (Page)']) ? 'text-primary cursor-pointer' : ''
																	}`}
																	onClick={() => {
																		if (hasEveryPermission(['View Estimation Details (Page)'])) {
																			handleOpenNewTab('invoices', payment?.credit_note?.id);
																		}
																	}}
																>
																	Credit Note {payment?.credit_note?.credit_note_number}
																</div>
															) : (
																'Credit Note'
															)
														) : payment?.pay_type == 'bank-charges' ? (
															'Bank Charges'
														) : payment?.pay_type == 'credit_card' ? (
															'Credit Card'
														) : payment?.pay_type == 'bank_cheque' ? (
															'Bank Cheque'
														) : payment?.pay_type == 'cash' ? (
															'Cash'
														) : payment?.pay_type == 'usdt' ? (
															'USDT'
														) : (
															'Wired'
														)}
													</div>
													<div className="col-md-3 text-success">
														{payment?.payment_amount && payment?.payment_currency ? (
															<>
																{getCurrencySymbol(payment?.payment_currency)} {numberFormatter.format(payment?.payment_amount)}
															</>
														) : (
															<>
																{getCurrencySymbol(selectedSalesOrder?.currency)} {numberFormatter.format(payment?.amount_paid)}
															</>
														)}
													</div>
													<div className="col-md-3">{payment?.user_created?.first_name}</div>
													<div className="hover-button-container-lg mr-20 mt0">
														<div>
															<div className="hover-button">
																{payment?.attachment && (
																	<div
																		className="btn btn-primary btn-outlined-main white-var btn-sm cursor-pointer"
																		style={{ marginLeft: '8px' }}
																		onClick={() => {
																			window.open(payment.attachment, '_blank');
																		}}
																	>
																		<div style={{ margin: 'auto 5px auto 3px' }}>
																			<FaPaperclip />
																		</div>
																	</div>
																)}
																<PermissionAllowed permissions={['Delete Payment Transaction']}>
																	<div
																		className="btn btn-danger white-var btn-sm cursor-pointer"
																		style={{ marginLeft: '8px' }}
																		onClick={() => {
																			deletePayment(payment?.id);
																		}}
																	>
																		<div style={{ margin: 'auto 3px' }}>
																			<DeleteIcon height="14px" width="14px" />
																		</div>
																	</div>
																</PermissionAllowed>
															</div>
														</div>
													</div>
												</div>
												<hr className="mt8 mb8" />
											</>
										))}
									</div>
								)}

								{selectedSalesOrder?.purchase_order?.length > 0 && (
									<PurchaseOrderComponent details={selectedSalesOrder?.purchase_order} />
								)}
								{selectedSalesOrder?.picklists?.length > 0 && (
									<PicklistComponent details={selectedSalesOrder?.picklists} />
								)}
								{selectedSalesOrder?.shipments?.length > 0 && <ShipmentsComponent details={selectedSalesOrder} />}
							</>
						)}
					</div>
					{isMobile && (
						<>
							<div style={{ height: '0px' }}></div>

							{selectedSalesOrder?.qoutation?.estimation_number && (
								<div className="mb-3 p-3 p-xl-4 w-100 new-card">
									<QoutationComponent details={selectedSalesOrder} isPageLoading={!selectedSalesOrder ? true : false} />
								</div>
							)}
							{selectedSalesOrder?.invoice?.invoice_number && (
								<div className="mb-3 p-3 p-xl-4 w-100 new-card">
									<InvoiceComponent details={selectedSalesOrder} isPageLoading={!selectedSalesOrder ? true : false} />
								</div>
							)}
							{selectedSalesOrder?.payments?.length > 0 && (
								<>
									<div className="mb-3 p-3 p-xl-4 w-100 new-card">
										<h2
											className="font600"
											style={{ fontSize: '18px', borderBottom: '1px solid #e0e0e0', paddingBottom: '10px', marginBottom: 0 }}
										>
											Payments
										</h2>
										{selectedSalesOrder?.payments?.map((payment, index) => (
											<div
												style={{
													display: 'flex',
													width: '100%',
													justifyContent: 'space-between',
													alignItems: 'center',
													borderBottom: '1px solid #eee',
													paddingTop: 5,
													paddingBottom: 5
												}}
												key={index}
											>
												<div style={{ display: 'flex', flexDirection: 'column' }}>
													<div style={{ fontWeight: 500 }}>
														{payment?.pay_type == 'credit-note'
															? 'Credit Note'
															: payment?.pay_type == 'bank-charges'
															? 'Bank Charges'
															: 'Wired'}
													</div>
													<div style={{ fontWeight: 400 }}>{moment(payment?.payment_date).format(CommonDateOnlyFormat)}</div>
												</div>
												<div style={{ display: 'flex', flexDirection: 'column' }}>
													<div style={{ fontWeight: 500 }}>
														{getCurrencySymbol(selectedSalesOrder?.currency)} {numberFormatter.format(payment?.amount_paid)}
													</div>
												</div>
												
											</div>
										))}
									</div>
								</>
							)}

							{selectedSalesOrder?.purchase_order?.length > 0 && (
								<div className="mb-3 p-3 p-xl-4 w-100 new-card">
									<PurchaseOrderComponent details={selectedSalesOrder?.purchase_order} />
								</div>
							)}
							{selectedSalesOrder?.picklists?.length > 0 && (
								<div className="mb-3 p-3 p-xl-4 w-100 new-card">
									<PicklistComponent details={selectedSalesOrder?.picklists} />
								</div>
							)}
							{selectedSalesOrder?.shipments?.length > 0 && (
								<div className="mb-3 p-3 p-xl-4 w-100 new-card">
									<ShipmentsComponent details={selectedSalesOrder} />
								</div>
							)}
						</>
					)}
					{orderAgreementsData?.length > 0 && (
						<>
							<div className="card shadow-sm rounded bg-white mb-3 p-3 p-xl-4 w-100">
								<div className="row">
									<div className="col-12">
										<div className="row">
											<div className="col-12">
												<div className="text-center mb-3 pt-2">
													<img src={agreementImage} alt="" height="70px" className="agreement-img" />
												</div>
											</div>
										</div>
										<div className="row">
											<div className="col-12">
												<h4 className="text-center mb-3">SALES AGREEMENT</h4>
											</div>
										</div>
										<div className="row">
											<div className="col-md-10 offset-md-1">
												<p className="text-center mb-3">
													This agreement is made on <Link to="#">{moment(selectedSalesOrder?.invoiceDate).format('DD MMMM YYYY')}</Link>{' '}
													between{' '}
													<Link to={`/contacts/${selectedSalesOrder?.customer?.id}`} target="_blank">
														<PrivacyModeContent>{selectedSalesOrder?.customer?.name}</PrivacyModeContent>
													</Link>
													,{' '}
													{selectedSalesOrder?.customer?.address && (
														<>
															located at{' '}
															<Link to="#">
																<PrivacyModeContent>
																	{selectedSalesOrder?.customer?.address ? `${selectedSalesOrder?.customer?.address}, ` : ''}
																	{selectedSalesOrder?.customer?.zipcode ? `${selectedSalesOrder?.customer?.zipcode}, ` : ''}
																	{selectedSalesOrder?.customer?.city ? `${selectedSalesOrder?.customer?.city}, ` : ''}
																	{selectedSalesOrder?.customer?.country ? `${selectedSalesOrder?.customer?.country}` : ''}
																</PrivacyModeContent>
															</Link>{' '}
															(The Client){' '}
														</>
													)}
													and{' '}
													{selectedSalesOrder?.transit_company?.name && (
														<>
															<Link to={`/contacts/${selectedSalesOrder?.transit_company?.id}`} target="_blank">
																{selectedSalesOrder?.transit_company?.name}
															</Link>{' '}
															{selectedSalesOrder?.transit_company?.address && (
																<>
																	located at{' '}
																	<Link to="#">
																		{selectedSalesOrder?.transit_company?.address
																			? `${selectedSalesOrder?.transit_company?.address}, `
																			: ''}
																		{selectedSalesOrder?.transit_company?.zipcode
																			? `${selectedSalesOrder?.transit_company?.zipcode}, `
																			: ''}
																		{selectedSalesOrder?.transit_company?.city ? `${selectedSalesOrder?.transit_company?.city}, ` : ''}
																		{selectedSalesOrder?.transit_company?.country
																			? `${selectedSalesOrder?.transit_company?.country}`
																			: ''}
																	</Link>{' '}
																</>
															)}
															(The Supplier).
														</>
													)}
												</p>
											</div>
										</div>

										<div className="row">
											<div className="col-md-10 offset-md-1">
												<p className="text-center mb-3">
													Both parties confirm that they have mutually agreed upon the following conditions, as negotiated between{' '}
													<b>
														{selectedSalesOrder?.sales_person?.first_name} {selectedSalesOrder?.sales_person?.last_name}
													</b>
													, {selectedSalesOrder?.transit_company?.name && <> representing {selectedSalesOrder?.transit_company?.name}</>},{' '}
													and{' '}
													{selectedSalesOrder?.customer?.contact_name ? (
														<>
															<Link to={`contact/${selectedSalesOrder?.customer?.id}`} target="_blank">
																<PrivacyModeContent>{selectedSalesOrder?.customer?.name}</PrivacyModeContent>
															</Link>
															, the representative of{' '}
														</>
													) : (
														''
													)}{' '}
													the representative of{' '}
													<Link to={`/contacts/${selectedSalesOrder?.customer?.id}`} target="_blank">
														<PrivacyModeContent>{selectedSalesOrder?.customer?.name}</PrivacyModeContent>
													</Link>
													.
												</p>
											</div>
										</div>

										<div className="order-agreements-detail-section">
											{selectedSalesOrder?.order_agreements?.length > 0 && (
												<>
													{selectedSalesOrder?.order_agreements?.map((ag) => (
														<div className="order-agreements-detail">
															<h6>{ag?.title}</h6>
															{ag?.type == 'multiselect' ? (
																ag?.responses?.map((res) => <p>{res?.option?.option}</p>)
															) : (
																<p>{ag?.response?.label}</p>
															)}
														</div>
													))}
													<div className="row">
														<div className="col-12">
															<p
																className="d-flex justify-content-center align-items-center text-center mb-4 pt-4"
																style={{ gap: '10px', color: '#838383', fontStyle: 'italic' }}
															>
																Note: <br />
																Please be aware that a 2% charge will be applied to the entire order amount if payment is not made on
																time,
																<br />
																due to fluctuations in USD and EUR currency values.
															</p>
														</div>
													</div>
												</>
											)}
										</div>
									</div>
								</div>
							</div>
						</>
					)}
					{selectedPaymentShipment === 'payment' && (
						<PaymentsComponent
							paymentData={paymentData}
							setPaymentData={setPaymentData}
							estimateDetails={selectedSalesOrder}
							onAddPayment={handleAddPayment}
							onUpdatePayment={handleUpdatePayment}
							onDeletePayment={handleDeletePayment}
							setShowAddPayment={setShowAddPaymentModal}
							showAddPayment={showAddPaymentModal}
							toggleExpand={handlePaymentToggle}
							showOnlyModal={true}
							source={'sales_order'}
						/>
					)}
				</div>
			</div>
			<div className="col-12 col-md-4 col-lg-4 col-xl-3 inv-details">
				<div className="mt-20">
					<div className="est-detail-item">
						<label htmlFor="inputName" className="est-labels">
							{!selectedSalesOrder ? (
								<div style={{ width: '100px', marginBottom: '5px' }}>
									<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
								</div>
							) : (
								'Currency & Rate'
							)}
						</label>
						<p>
							{!selectedSalesOrder ? (
								<div style={{ width: '110px', marginBottom: '5px' }}>
									<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
								</div>
							) : (
								<>
									{selectedSalesOrder?.currency?.toUpperCase()}, 1 ={' '}
									{selectedSalesOrder?.currency == 'eur'
										? `$ ${(
												(1 / selectedSalesOrder?.currency_rate?.currency_rates[1]?.rate) *
												selectedSalesOrder?.currency_rate?.currency_rates[2]?.rate
											).toFixed(4)}`
										: selectedSalesOrder?.currency == 'usd'
										? `€ ${(
												(1 / selectedSalesOrder?.currency_rate?.currency_rates[2]?.rate) *
												selectedSalesOrder?.currency_rate?.currency_rates[1]?.rate
											).toFixed(4)}`
										: selectedSalesOrder?.currency == 'aed'
										? `€ ${(
												(1 / selectedSalesOrder?.currency_rate?.currency_rates[0]?.rate) *
												selectedSalesOrder?.currency_rate?.currency_rates[1]?.rate
											).toFixed(4)}`
										: ''}
								</>
							)}
						</p>
					</div>
					{!selectedSalesOrder ? (
						<>
							<div className="est-detail-item">
								<div>
									<div style={{ width: '150px', marginBottom: '11px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
									</div>
								</div>
								<div>
									<div style={{ width: '150px', marginBottom: '11px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
									</div>
								</div>
							</div>
							<div className="est-detail-item">
								<div>
									<div style={{ width: '150px', marginBottom: '11px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
									</div>
								</div>
								<div>
									<div style={{ width: '150px', marginBottom: '11px' }}>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
									</div>
								</div>
							</div>
						</>
					) : (
						<>
							<div className="est-detail-item">
								<label htmlFor="inputName" className="est-labels">
									{!selectedSalesOrder ? (
										<div style={{ width: '100px', marginBottom: '4px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
										</div>
									) : (
										'Transit'
									)}
								</label>
								<div>
									{!selectedSalesOrder ? (
										<div style={{ width: '120px', marginBottom: '4px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
										</div>
									) : (
										selectedSalesOrder?.transit_company?.name ? (
											<Link to={`/contacts/${selectedSalesOrder?.transit_company?.id}`}>
												<PrivacyModeContent>
													{
														isMobile ? (
															selectedSalesOrder?.transit_company?.name
														) : (
															<>
																{selectedSalesOrder?.transit_company?.name?.length > 30 ? selectedSalesOrder?.transit_company?.name.slice(0, 30) + '...' : selectedSalesOrder?.transit_company?.name}
															</>
														)
													}
												</PrivacyModeContent>
											</Link>
										) : (
											<div className="text-gray-600">-----</div>	
										)
									)}
								</div>
							</div>
							<div className="est-detail-item">
								<label htmlFor="inputName" className="est-labels">
									{!selectedSalesOrder ? (
										<div style={{ width: '100px', marginBottom: '4px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
										</div>
									) : (
										'Customer'
									)}
								</label>

								<div>
									{!selectedSalesOrder ? (
										<div style={{ width: '120px', marginBottom: '4px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
										</div>
									) : (
										<Link to={`/contacts/${selectedSalesOrder?.customer?.id}`}>
											<PrivacyModeContent notUserRestricted>
												{
													isMobile ? (
														selectedSalesOrder?.customer?.name
													) : (
														<>
															{selectedSalesOrder?.customer?.name?.length > 21 ? selectedSalesOrder?.customer?.name.slice(0, 21) + '...' : selectedSalesOrder?.customer?.name}
														</>
													)
												}
											</PrivacyModeContent>
										</Link>
									)}
								</div>
							</div>
						</>
					)}
					<div className="est-detail-item">
						<label htmlFor="inputName" className="est-labels">
							{!selectedSalesOrder ? (
								<div style={{ width: '100px', marginBottom: '4px' }}>
									<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
								</div>
							) : (
								'Sales Manager'
							)}
						</label>
						<div>
							{!selectedSalesOrder ? (
								<div style={{ width: '100px', marginBottom: '4px' }}>
									<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
								</div>
							) : (
								<Link to={`/settings/user/${selectedSalesOrder?.sales_person?.id}`}>
									{selectedSalesOrder?.sales_person?.first_name} {selectedSalesOrder?.sales_person?.last_name}
								</Link>
							)}
						</div>
					</div>
					{selectedSalesOrder && (
						selectedSalesOrder?.master_status?.name == 'Open' && (
							<div className="mt20">
								<TimelineStep
									selectedSalesOrder={selectedSalesOrder}
									startDateParam={selectedSalesOrder?.start_at}
									endDateParam={selectedSalesOrder?.expires_at}
								/>
							</div>
						)
					)}
					{!selectedSalesOrder ? (
						<div className="form-group mb-2 mt-3">
							<label htmlFor="inputName" className="est-labels">
								<div style={{ width: '100px', marginBottom: '4px' }}>
									<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
								</div>
							</label>

							<div>
								<div style={{ width: '100%', marginBottom: '14px' }}>
									<div>
										<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
									</div>
								</div>
								<div style={{ width: '110px', marginBottom: '14px' }}>
									<div>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
									</div>
								</div>
								<div style={{ width: '100%', marginBottom: '14px' }}>
									<div>
										<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }}></Skeleton>
									</div>
								</div>
							</div>
						</div>
					) : (
						<Notes
							notes={salesOrderRow?.notes}
							addNote={addNote}
							deleteNotePermission={[]}
							removeNote={removeNote}
							toggleNoteExpand={toggleNoteExpand}
							parentId={1}
							type="estimate"
						/>
					)}
				</div>
			</div>

			{openSendEmailPopup && !isMobile && (
				<SendEmailModal
					openPopup={openSendEmailPopup}
					selectedEstimate={selectedSalesOrder}
					handleClose={closeSendEmailPopup}
					sendEstimateEmail={handleSendEmail}
					sendingEstimate={sendingSalesOrder}
					selectedForSending={selectedForSending}
					disableStatus={false}
				/>
			)}
			{openSendEmailPopup && isMobile && (
				<SendEmailModalMobile
					openPopup={openSendEmailPopup}
					selectedEstimate={selectedSalesOrder}
					handleClose={closeSendEmailPopup}
					sendEstimateEmail={handleSendEmail}
					sendingEstimate={sendingSalesOrder}
					selectedForSending={selectedForSending}
					disableStatus={false}
				/>
			)}

			{showDeletePopup && (
				<DeleteConfirmation
					show={showDeletePopup}
					handleClose={handleClosePopup}
					handleDelete={handleDelete}
					title="Confirm"
					message={`${deleteMessage}`}
				/>
			)}

			{showCancelPopup && (
				<DeleteConfirmation
					show={showCancelPopup}
					handleClose={handleClosePopup}
					handleDelete={handleCancel}
					title="Are you sure?"
					message={`${deleteMessage}`}
					// customDeleteButtonText="Confirm"
					customDeleteButtonText={`Yes, Cancel this Sales Order`}
				/>
			)}
			{showClosePopup && (
				<DeleteConfirmation
					show={showClosePopup}
					handleClose={handleCloseSalesOrder}
					handleDelete={handleCloseSalesOrder}
					title="Confirm"
					message={`${deleteMessage}`}
					customDeleteButtonText="Confirm"
				/>
			)}


			{showProcessOrderModal && (
				<ProcessOrderModal
					openPopup={showProcessOrderModal}
					collection={selectedSalesOrder}
					handleClose={handleClosePopup}
					handleReloadDetails={handleReloadDetails}
					handleProcessPurchaseOrder={handleCreatePurchaseOrder}
					handleSendToOperation={handleCreatePurchaseOrder}
				/>
			)}

			{showPurchaseOrderModal && (
				<PurchaseOrderModal
					openPopup={showPurchaseOrderModal}
					selectedSalesOrder={selectedSalesOrder}
					handleClose={closePurchaseOrderPopup}
					handleItems={null}
					handleCreatePurchaseOrder={handleCreatePurchaseOrder}
				/>
			)}
			{showDeletePayment && (
				<DeleteConfirmation
					key="paymentDelete"
					show={showDeletePayment}
					handleClose={handleClosePopup}
					handleDelete={handleDeletePayment}
					title="Confirm"
					message={`Are you sure you want to delete this payment?`}
				/>
			)}
			{showDeleteSalesOrderPopup && (
				<DeleteConfirmation
					show={showDeleteSalesOrderPopup}
					handleClose={() => {
						setShowDeleteSalesOrderPopup(false);
					}}
					handleDelete={handleDeleteSalesOrder}
					title="Confirm"
					message={`Are you sure you want to delete sales order ${selectedSalesOrder?.sales_order_number}? This action cannot be undone.`}
				/>
			)}
		</div>
	);
};

export default SalesOrderDetails;
